import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';

interface FetchLedgerParams {
  employeeId: number;
  startDate?: string;
  endDate?: string;
}

// Add annual interest
export const addAnnualInterest = createAsyncThunk('pfLedger/addInterest',
  async (data: {pfEmployeeId: number;interestRate: number;createdBy: number;year?: number;},
    { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/pf/add-interest', data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to add interest');
    }
  }
);

// Get ledger with account details

export const fetchLedgerWithAccountDetails = createAsyncThunk(
  'pfLedger/fetchLedger',
  async (
    { employeeId, startDate, endDate }: FetchLedgerParams,
    { rejectWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams();

      if (startDate) queryParams.append('startDate', startDate);
      if (endDate) queryParams.append('endDate', endDate);

      const url = `/pf-ledger/${employeeId}/account-details${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

      const res = await payrollServiceApiInstance.get(url);
      return res.data; // Should match { pfEmployee, ledgerTransactions }
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch ledger and account details');
    }
  }
);
export const fetchInterestSummaryByYear = createAsyncThunk('pfLedger/fetchInterestSummaryByYear',
  async (params: { year?: number; interestRate?: number },
    { rejectWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.year) queryParams.append('year', params.year.toString());
      if (params.interestRate) queryParams.append('interestRate', params.interestRate.toString());

      const url = `/pf-ledger/interest-summary${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const res = await payrollServiceApiInstance.get(url);
      return res.data; // Should be an array of interest summary objects
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch interest summary');
    }
  }
);


